import { createIcon } from '@chakra-ui/icons'

// using `path`
export const DsaIcon = createIcon({
  displayName: 'DsaIcon',
  viewBox:"0, 0, 550,550",

  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g transform="translate(0.000000,400.000000) scale(0.100000,-0.100000)"
fill="black" stroke="none">
<path d="M2180 3850 c0 -6 -43 -10 -110 -10 -67 0 -110 -4 -110 -10 0 -5 -13
-10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -9 -10 -20 -10 -11 0 -20 5 -20 10 0 6
-4 10 -10 10 -5 0 -10 -9 -10 -20 0 -12 -7 -20 -16 -20 -18 0 -44 -23 -44 -40
0 -16 -87 -100 -105 -100 -8 0 -15 -9 -15 -20 0 -11 -4 -20 -10 -20 -5 0 -10
-9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30
-6 0 -10 -27 -10 -60 0 -33 -4 -60 -10 -60 -5 0 -10 -13 -10 -30 0 -16 5 -30
10 -30 6 0 10 -22 10 -50 0 -27 5 -50 10 -50 6 0 10 -13 10 -30 0 -16 5 -30
10 -30 6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -13 7 -20 20
-20 15 0 20 -7 20 -25 0 -33 42 -75 75 -75 18 0 25 -5 25 -20 0 -13 7 -20 20
-20 11 0 20 -4 20 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 14 -10 30
-10 17 0 30 -4 30 -10 0 -6 50 -10 130 -10 80 0 130 -4 130 -10 0 -5 5 -10 10
-10 6 0 10 9 10 20 0 13 7 20 20 20 11 0 20 -4 20 -10 0 -5 5 -10 10 -10 6 0
10 9 10 20 0 13 7 20 20 20 13 0 20 7 20 20 0 11 5 20 10 20 6 0 10 -9 10 -20
0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 7 10 15 0 20 65 85
85 85 10 0 15 10 15 30 0 23 4 30 20 30 16 0 20 7 20 30 0 17 5 30 10 30 6 0
10 14 10 30 0 23 4 30 20 30 11 0 20 5 20 10 0 6 -4 10 -10 10 -6 0 -10 43
-10 110 0 67 -4 110 -10 110 -5 0 -10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 9
-10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 19 0 11 -6 22 -12 25 -10 5 -10 7 0
12 19 9 14 24 -8 24 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -13 0 -20 7 -20 18
0 10 -9 24 -20 32 -11 8 -20 22 -20 32 0 21 -16 24 -24 6 -5 -10 -7 -10 -12 0
-3 6 -14 12 -25 12 -10 0 -19 5 -19 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0
6 -13 10 -30 10 -23 0 -30 4 -30 20 0 11 -4 20 -10 20 -5 0 -10 -4 -10 -10z"/>
<path d="M1700 3710 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2500 2862 c0 -10 -9 -24 -20 -32 -11 -8 -20 -26 -20 -40 0 -14 9
-32 20 -40 11 -8 20 -21 20 -28 0 -7 18 -31 40 -52 22 -21 40 -44 40 -50 0
-17 26 -40 44 -40 9 0 16 -8 16 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -4 -10 -10
0 -5 7 -10 15 -10 18 0 85 -64 85 -81 0 -6 14 -24 32 -41 25 -23 29 -31 18
-38 -8 -5 -11 -13 -6 -17 5 -4 11 -2 13 5 7 17 23 15 23 -4 0 -20 24 -44 44
-44 9 0 16 -8 16 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -4 -10 -10 0 -5 7 -10 15
-10 18 0 85 -64 85 -81 0 -6 14 -24 30 -39 29 -27 40 -60 20 -60 -5 0 -10 -8
-10 -18 0 -10 -9 -24 -20 -32 -11 -8 -20 -22 -20 -32 0 -10 -4 -18 -10 -18 -5
0 -10 -18 -10 -40 0 -22 -4 -40 -10 -40 -5 0 -10 -22 -10 -50 0 -27 -4 -50
-10 -50 -5 0 -10 -4 -10 -10 0 -5 9 -10 20 -10 16 0 20 -7 20 -38 0 -26 6 -42
20 -52 11 -8 20 -18 20 -22 0 -4 -9 -8 -20 -8 -11 0 -20 -4 -20 -10 0 -5 7
-10 16 -10 18 0 44 -24 44 -40 0 -7 14 -25 30 -40 17 -15 30 -35 30 -44 0 -9
5 -16 10 -16 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 -9 10 -20 0 -13 7 -20 20
-20 11 0 20 -4 20 -10 0 -5 14 -10 30 -10 23 0 30 -4 30 -20 0 -11 5 -20 10
-20 6 0 10 5 10 10 0 6 33 10 80 10 47 0 80 -4 80 -10 0 -5 5 -10 10 -10 6 0
10 9 10 20 0 13 7 20 20 20 11 0 20 -4 20 -10 0 -5 5 -10 10 -10 6 0 10 9 10
20 0 13 7 20 20 20 13 0 20 7 20 20 0 15 7 20 26 20 33 0 54 21 54 54 0 19 5
26 20 26 13 0 20 7 20 20 0 11 5 20 10 20 6 0 10 9 10 20 0 13 7 20 20 20 11
0 20 5 20 10 0 6 -4 10 -10 10 -15 0 -12 97 3 104 10 5 10 7 0 12 -8 4 -13 27
-13 65 0 33 -4 59 -10 59 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10
19 0 11 -6 22 -12 25 -10 5 -10 7 0 12 18 8 15 24 -6 24 -10 0 -24 9 -32 20
-8 12 -26 20 -42 20 -21 0 -28 5 -28 20 0 13 -7 20 -20 20 -11 0 -20 5 -20 10
0 6 -13 10 -30 10 -16 0 -30 5 -30 10 0 6 -40 10 -100 10 -60 0 -100 -4 -100
-10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -16 -30 -12 -48 7 -12 12
-13 18 -4 21 17 5 15 22 -3 22 -18 0 -85 64 -85 80 0 7 -18 29 -40 50 -22 21
-40 44 -40 50 0 17 -26 40 -44 40 -9 0 -16 8 -16 20 0 11 5 20 10 20 6 0 10 5
10 10 0 6 -7 10 -15 10 -18 0 -85 64 -85 80 0 17 -26 40 -44 40 -9 0 -16 8
-16 20 0 11 5 20 10 20 6 0 10 5 10 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10 0
6 -9 10 -20 10 -13 0 -20 7 -20 20 0 11 -4 20 -10 20 -5 0 -10 7 -10 16 0 9
-15 30 -32 47 -21 19 -28 32 -20 34 18 7 15 23 -6 23 -10 0 -24 9 -32 20 -18
25 -30 26 -30 2z"/>
<path d="M1563 2835 c-13 -13 -23 -29 -23 -35 0 -7 -18 -29 -40 -50 -22 -21
-40 -44 -40 -50 0 -6 -18 -29 -40 -50 -22 -21 -40 -46 -40 -54 0 -9 -4 -16
-10 -16 -5 0 -10 -9 -10 -20 0 -12 -7 -20 -16 -20 -18 0 -44 -23 -44 -40 0 -6
-18 -29 -40 -50 -22 -21 -40 -46 -40 -54 0 -9 -4 -16 -10 -16 -5 0 -10 -9 -10
-20 0 -12 -7 -20 -16 -20 -18 0 -44 -23 -44 -40 0 -6 -18 -29 -40 -50 -22 -21
-40 -43 -40 -50 0 -20 -49 -60 -75 -60 -14 0 -25 5 -25 10 0 6 -9 10 -20 10
-11 0 -20 5 -20 10 0 6 -40 10 -100 10 -60 0 -100 4 -100 10 0 6 -4 10 -10 10
-5 0 -10 -9 -10 -20 0 -13 -7 -20 -20 -20 -11 0 -20 5 -20 10 0 6 -4 10 -10
10 -5 0 -10 -9 -10 -20 0 -13 -7 -20 -20 -20 -12 0 -20 -7 -20 -16 0 -20 -24
-44 -43 -44 -9 0 -18 -6 -20 -12 -4 -10 -8 -9 -16 2 -5 8 -14 11 -18 6 -4 -5
-2 -11 5 -13 21 -8 14 -43 -8 -43 -13 0 -20 -7 -20 -20 0 -11 -4 -20 -10 -20
-5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -6 0 -10 -43 -10 -110 0 -67 4
-110 10 -110 6 0 10 -9 10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -4 -10 -10 0 -5
9 -10 20 -10 11 0 20 -4 20 -10 0 -5 -4 -10 -10 -10 -5 0 -10 -4 -10 -10 0 -5
11 -10 25 -10 26 0 95 -59 95 -80 0 -20 28 -40 54 -40 14 0 26 -4 26 -10 0 -5
14 -10 30 -10 17 0 30 -4 30 -10 0 -15 77 -12 84 3 5 10 7 10 12 0 7 -15 84
-18 84 -3 0 6 14 10 30 10 17 0 30 5 30 10 0 6 9 10 20 10 11 0 20 5 20 10 0
6 9 10 20 10 11 0 20 7 20 15 0 20 45 65 65 65 8 0 15 9 15 20 0 11 5 20 10
20 6 0 10 9 10 20 0 11 5 20 10 20 6 0 10 14 10 30 0 23 4 30 20 30 11 0 20 5
20 10 0 6 -4 10 -10 10 -6 0 -10 30 -10 70 0 40 4 70 10 70 6 0 10 5 10 10 0
6 -9 10 -20 10 -16 0 -20 7 -20 30 0 17 -4 30 -10 30 -5 0 -10 9 -10 20 0 11
-4 20 -10 20 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 11 -10 25 0 29 59
95 85 95 8 0 15 5 15 10 0 6 -4 10 -10 10 -5 0 -10 9 -10 20 0 13 7 20 18 20
10 0 24 9 32 20 8 11 22 20 32 20 21 0 24 16 6 23 -8 2 4 20 30 45 28 27 42
49 42 66 0 17 6 26 15 26 20 0 65 45 65 65 0 8 5 15 10 15 6 0 10 9 10 20 0
12 7 20 16 20 18 0 44 23 44 40 0 6 18 29 40 50 22 21 40 46 40 54 0 9 5 16
10 16 6 0 10 9 10 20 0 11 7 20 15 20 22 0 73 52 57 58 -7 2 -12 12 -12 23 0
12 -7 19 -20 19 -11 0 -20 5 -20 10 0 18 -35 9 -57 -15z"/>
<path d="M2420 2810 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2013 2685 c-10 -10 -13 -77 -13 -260 l0 -245 -30 0 c-16 0 -30 -4
-30 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10 0 -5 -9 -10 -20 -10 -13 0
-20 -7 -20 -20 0 -15 -7 -20 -28 -20 -16 0 -34 -8 -42 -20 -8 -11 -22 -20 -32
-20 -10 0 -18 -4 -18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0 -5 -9 -10
-20 -10 -13 0 -20 -7 -20 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -13
-7 -20 -20 -20 -11 0 -20 -4 -20 -10 0 -5 5 -10 10 -10 6 0 10 -43 10 -110 0
-67 -4 -110 -10 -110 -5 0 -10 -4 -10 -10 0 -5 9 -10 20 -10 13 0 20 -7 20
-20 0 -11 5 -20 10 -20 6 0 10 -9 10 -20 0 -13 7 -20 20 -20 16 0 20 -7 20
-30 0 -23 4 -30 20 -30 22 0 27 -16 8 -23 -8 -2 -9 -8 -4 -13 5 -5 11 -4 13 4
8 21 43 14 43 -8 0 -13 7 -20 20 -20 13 0 20 -7 20 -20 0 -11 5 -20 10 -20 6
0 10 5 10 10 0 6 9 10 20 10 11 0 20 -4 20 -10 0 -6 37 -10 90 -10 53 0 90 -4
90 -10 0 -5 5 -10 10 -10 6 0 10 9 10 20 0 16 7 20 30 20 17 0 30 5 30 10 0 6
9 10 19 10 11 0 22 6 25 13 5 10 7 10 12 0 8 -18 24 -16 24 3 0 9 14 29 30 44
17 15 30 34 30 42 0 7 9 20 20 28 11 8 20 22 20 32 0 10 5 18 10 18 6 0 10 18
10 40 0 33 3 40 20 40 11 0 20 5 20 10 0 6 -4 10 -10 10 -5 0 -10 23 -10 50 0
28 5 50 10 50 6 0 10 5 10 10 0 6 -9 10 -20 10 -16 0 -20 7 -20 30 0 17 5 30
10 30 6 0 10 5 10 10 0 6 -9 10 -20 10 -13 0 -20 7 -20 19 0 11 -6 22 -12 25
-10 5 -10 7 0 12 19 9 14 24 -8 24 -11 0 -20 5 -20 10 0 6 -9 10 -20 10 -12 0
-20 7 -20 16 0 23 -25 44 -52 44 -13 0 -30 9 -38 20 -8 11 -22 20 -32 20 -11
0 -18 7 -18 20 0 13 -7 20 -20 20 -19 0 -20 7 -20 236 0 191 -3 238 -14 250
-18 17 -42 18 -50 2 -5 -10 -7 -10 -12 0 -7 15 -16 15 -31 -3z"/>
<path d="M540 2110 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1260 1490 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1220 1450 c0 -5 5 -10 10 -10 14 0 12 -38 -2 -42 -16 -6 35 -58 57
-58 8 0 15 -4 15 -10 0 -5 9 -10 20 -10 13 0 20 -7 20 -18 0 -10 9 -24 20 -32
11 -8 20 -22 20 -32 0 -10 5 -18 10 -18 6 0 10 5 10 10 0 6 9 10 20 10 12 0
20 -7 20 -16 0 -9 14 -29 30 -44 17 -15 30 -35 30 -44 0 -9 5 -16 10 -16 6 0
10 5 10 10 0 6 9 10 20 10 11 0 20 -7 20 -15 0 -20 45 -65 65 -65 8 0 15 -4
15 -10 0 -5 9 -10 20 -10 11 0 20 -7 20 -15 0 -20 45 -65 65 -65 8 0 15 -4 15
-10 0 -5 9 -10 20 -10 13 0 20 -7 20 -18 0 -10 9 -24 20 -32 11 -8 20 -22 20
-32 0 -21 16 -24 24 -5 5 10 7 10 12 0 3 -7 14 -13 25 -13 11 0 19 -7 19 -16
0 -20 24 -44 44 -44 9 0 16 -4 16 -10 0 -5 9 -10 20 -10 13 0 20 -7 20 -18 0
-10 9 -24 20 -32 11 -8 20 -22 20 -32 0 -10 5 -18 10 -18 6 0 10 5 10 10 0 6
9 10 20 10 12 0 20 -7 20 -16 0 -9 14 -29 30 -44 17 -15 30 -35 30 -44 0 -9 5
-16 10 -16 6 0 10 5 10 10 0 6 9 10 20 10 13 0 20 -7 20 -20 0 -11 5 -20 10
-20 6 0 10 -9 10 -20 0 -13 7 -20 20 -20 11 0 20 -4 20 -10 0 -5 -9 -10 -20
-10 -11 0 -20 -4 -20 -10 0 -5 5 -10 10 -10 6 0 10 -33 10 -80 0 -47 -4 -80
-10 -80 -5 0 -10 -4 -10 -10 0 -5 9 -10 20 -10 13 0 20 -7 20 -20 0 -12 7 -20
16 -20 20 0 44 -24 44 -44 0 -9 8 -16 20 -16 11 0 20 -4 20 -10 0 -5 18 -10
40 -10 33 0 40 -3 40 -20 0 -26 31 -26 50 0 8 11 26 20 40 20 14 0 32 9 40 20
8 12 26 20 42 20 24 0 28 4 28 30 0 23 4 30 20 30 16 0 20 7 20 30 0 17 5 30
10 30 6 0 10 27 10 60 0 33 -4 60 -10 60 -5 0 -10 14 -10 30 0 17 -4 30 -10
30 -5 0 -10 8 -10 18 0 10 -9 24 -20 32 -11 8 -20 22 -20 32 0 10 -4 18 -10
18 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10 -20 -5 0 -10 9 -10 20 0 16 -7 20
-30 20 -23 0 -30 4 -30 20 0 11 -4 20 -10 20 -5 0 -10 -4 -10 -10 0 -5 -18
-10 -40 -10 -22 0 -40 -4 -40 -10 0 -5 -13 -10 -30 -10 -16 0 -30 -4 -30 -10
0 -14 -37 -12 -43 3 -4 9 -8 9 -15 -2 -8 -12 -18 -6 -50 27 -22 23 -48 42 -56
42 -19 0 -21 16 -3 23 7 2 8 8 3 13 -5 5 -11 4 -13 -3 -7 -18 -43 -16 -43 2 0
20 -45 65 -65 65 -18 0 -20 16 -2 23 7 2 8 8 3 13 -5 5 -11 4 -13 -3 -7 -18
-43 -16 -43 2 0 20 -45 65 -65 65 -18 0 -20 16 -2 23 7 2 8 8 3 13 -5 5 -11 4
-13 -3 -7 -18 -43 -16 -43 2 0 20 -45 65 -65 65 -18 0 -20 16 -2 23 7 2 8 8 3
13 -5 5 -11 4 -13 -3 -7 -18 -43 -16 -43 2 0 20 -45 65 -65 65 -18 0 -20 16
-2 23 7 2 8 8 3 13 -5 5 -11 4 -13 -3 -7 -18 -43 -16 -43 2 0 20 -45 65 -65
65 -18 0 -20 16 -2 23 7 2 8 8 3 13 -5 5 -11 4 -13 -3 -7 -18 -43 -16 -43 2 0
20 -45 65 -65 65 -18 0 -20 16 -2 23 7 2 8 8 3 13 -5 5 -11 4 -13 -3 -9 -27
-63 -3 -63 27 0 17 -26 40 -44 40 -19 0 -21 16 -3 23 7 2 8 8 3 13 -5 5 -11 4
-13 -3 -9 -27 -63 -3 -63 27 0 19 -33 47 -38 32 -4 -14 -42 -16 -42 -2 0 6 -4
10 -10 10 -5 0 -10 -4 -10 -10z"/>
<path d="M3440 1290 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M580 1240 c0 -22 -4 -40 -10 -40 -5 0 -10 -13 -10 -30 0 -16 -4 -30
-10 -30 -5 0 -10 -13 -10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -13 -10 -30 0
-16 -4 -30 -10 -30 -5 0 -10 -13 -10 -30 0 -23 -4 -30 -20 -30 -11 0 -20 -4
-20 -10 0 -5 5 -10 10 -10 6 0 10 -9 10 -20 0 -13 -7 -20 -20 -20 -11 0 -20
-4 -20 -10 0 -5 5 -10 10 -10 6 0 10 -9 10 -20 0 -11 -4 -20 -10 -20 -5 0 -10
-16 -10 -35 0 -27 -8 -44 -35 -70 -33 -33 -85 -48 -85 -25 0 6 -4 10 -10 10
-5 0 -10 -9 -10 -20 0 -13 -7 -20 -20 -20 -12 0 -20 -7 -20 -16 0 -20 -24 -44
-44 -44 -9 0 -16 -8 -16 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -13 -10 -30 0 -23
-4 -30 -20 -30 -11 0 -20 -4 -20 -10 0 -5 5 -10 10 -10 6 0 10 -18 10 -40 0
-22 5 -40 10 -40 6 0 10 -13 10 -30 0 -23 4 -30 20 -30 11 0 20 -4 20 -10 0
-5 -9 -10 -20 -10 -11 0 -20 -4 -20 -10 0 -5 8 -10 18 -10 10 0 24 -9 32 -20
8 -11 22 -20 32 -20 10 0 18 -4 18 -10 0 -5 9 -10 20 -10 11 0 20 -4 20 -10 0
-6 30 -10 70 -10 40 0 70 4 70 10 0 6 13 10 29 10 16 0 32 6 35 13 5 9 7 9 12
0 9 -20 24 -15 24 7 0 11 5 20 10 20 6 0 10 14 10 30 0 27 3 30 30 30 17 0 30
5 30 10 0 6 -4 10 -10 10 -5 0 -10 14 -10 30 0 23 4 30 20 30 15 0 20 7 20 28
0 16 -8 34 -20 42 -12 8 -20 26 -20 42 0 15 -4 28 -10 28 -5 0 -10 9 -10 20 0
13 -7 20 -20 20 -13 0 -20 7 -20 18 0 10 -9 24 -20 32 -14 10 -20 26 -20 52 0
21 5 38 10 38 6 0 10 14 10 30 0 23 4 30 20 30 11 0 20 5 20 10 0 6 -4 10 -10
10 -5 0 -10 9 -10 20 0 13 7 20 20 20 11 0 20 5 20 10 0 6 -4 10 -10 10 -5 0
-10 9 -10 20 0 13 7 20 20 20 11 0 20 5 20 10 0 6 -4 10 -10 10 -5 0 -10 9
-10 20 0 11 5 20 10 20 6 0 10 18 10 40 0 22 5 40 10 40 6 0 10 14 10 30 0 17
5 30 10 30 6 0 10 13 10 29 0 16 6 32 13 34 9 4 8 8 -3 17 -11 9 -12 13 -2 17
23 9 12 23 -18 23 -16 0 -30 5 -30 10 0 6 -9 10 -20 10 -17 0 -20 -7 -20 -40z"/>
<path d="M920 1250 c0 -16 5 -30 10 -30 6 0 10 -13 10 -30 0 -16 5 -30 10 -30
6 0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6
0 10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0
10 -9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10
-9 10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -9
10 -20 0 -11 5 -20 10 -20 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -9 10
-20 0 -11 5 -20 10 -20 22 0 9 -53 -20 -80 -16 -15 -30 -35 -30 -44 0 -9 -4
-16 -10 -16 -5 0 -10 -13 -10 -30 0 -23 -4 -30 -20 -30 -11 0 -20 -4 -20 -10
0 -5 5 -10 10 -10 6 0 10 -18 10 -40 0 -22 5 -40 10 -40 6 0 10 -13 10 -30 0
-16 5 -30 10 -30 6 0 10 -9 10 -20 0 -12 7 -20 16 -20 23 0 44 -25 44 -54 0
-14 5 -26 10 -26 6 0 10 5 10 10 0 6 9 10 20 10 11 0 20 -4 20 -10 0 -6 33
-10 80 -10 47 0 80 4 80 10 0 6 9 10 20 10 11 0 20 5 20 10 0 6 8 10 18 10 10
0 24 9 32 20 8 11 22 20 32 20 10 0 18 5 18 10 0 6 -9 10 -20 10 -11 0 -20 5
-20 10 0 6 14 10 30 10 17 0 30 5 30 10 0 6 -4 10 -10 10 -19 0 -10 53 12 71
l21 19 -21 19 c-22 18 -31 71 -12 71 6 0 10 5 10 10 0 6 -13 10 -30 10 -30 0
-41 15 -18 22 16 6 -35 58 -57 58 -8 0 -15 5 -15 10 0 6 -9 10 -20 10 -13 0
-20 7 -20 20 0 11 -4 20 -10 20 -5 0 -10 -4 -10 -10 0 -5 -16 -10 -35 -10 -38
0 -85 36 -85 65 0 8 -4 15 -10 15 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0
-10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 9 -10 20 0 11 -4 20 -10 20 -5 0
-10 14 -10 30 0 17 -4 30 -10 30 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 5
10 10 0 6 -9 10 -20 10 -13 0 -20 7 -20 20 0 11 -4 20 -10 20 -5 0 -10 9 -10
20 0 11 5 20 10 20 6 0 10 5 10 10 0 6 -9 10 -20 10 -13 0 -20 7 -20 20 0 11
-4 20 -10 20 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 5 10 10 0 6 -9 10 -20
10 -13 0 -20 7 -20 20 0 11 -4 20 -10 20 -5 0 -10 11 -10 25 0 29 -51 88 -58
67 -4 -14 -42 -16 -42 -2 0 6 -4 10 -10 10 -5 0 -10 -13 -10 -30z"/>
<path d="M3360 1253 c-16 -17 -20 -28 -12 -31 7 -2 12 -21 12 -43 0 -21 5 -39
10 -39 6 0 10 -13 10 -30 0 -16 5 -30 10 -30 6 0 10 -13 10 -30 0 -16 5 -30
10 -30 6 0 10 -13 10 -30 0 -16 -4 -30 -10 -30 -5 0 -10 -4 -10 -10 0 -5 9
-10 20 -10 16 0 20 -7 20 -30 0 -16 5 -30 10 -30 6 0 10 -13 10 -30 0 -16 -4
-30 -10 -30 -5 0 -10 -4 -10 -10 0 -5 9 -10 20 -10 16 0 20 -7 20 -30 0 -16 5
-30 10 -30 18 0 11 -55 -10 -70 -11 -8 -20 -20 -20 -28 0 -18 -25 -42 -44 -42
-19 0 -21 -16 -3 -23 8 -3 5 -11 -10 -24 -20 -17 -23 -30 -23 -87 0 -37 4 -66
10 -66 6 0 10 -13 10 -30 0 -20 5 -30 15 -30 20 0 65 -45 65 -65 0 -8 9 -15
20 -15 13 0 20 -7 20 -20 0 -11 5 -20 10 -20 6 0 10 5 10 10 0 6 30 10 70 10
40 0 70 -4 70 -10 0 -5 5 -10 10 -10 6 0 10 9 10 20 0 13 7 20 20 20 13 0 20
7 20 20 0 17 7 20 40 20 22 0 40 5 40 10 0 6 -9 10 -20 10 -11 0 -20 5 -20 10
0 6 9 10 20 10 13 0 20 7 20 20 0 11 5 20 10 20 6 0 10 37 10 90 0 53 -4 90
-10 90 -5 0 -10 9 -10 20 0 13 -7 20 -20 20 -13 0 -20 7 -20 20 0 13 -7 20
-20 20 -13 0 -20 7 -20 20 0 13 -7 20 -20 20 -13 0 -20 7 -20 20 0 11 -4 20
-10 20 -5 0 -10 -4 -10 -10 0 -5 -13 -10 -30 -10 -23 0 -30 4 -30 20 0 13 -7
20 -20 20 -17 0 -20 7 -20 40 0 22 -4 40 -10 40 -5 0 -10 14 -10 30 0 17 -4
30 -10 30 -5 0 -10 18 -10 40 0 22 -4 40 -10 40 -5 0 -10 9 -10 20 0 11 5 20
10 20 6 0 10 5 10 10 0 6 -9 10 -20 10 -16 0 -20 7 -20 30 0 17 -4 30 -10 30
-5 0 -10 14 -10 30 0 17 5 30 10 30 6 0 10 5 10 10 0 6 -9 10 -20 10 -16 0
-20 7 -20 30 0 17 -4 30 -10 30 -5 0 -10 7 -10 16 0 19 -24 44 -42 43 -7 0
-24 -12 -38 -26z"/>
<path d="M3800 630 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3760 270 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
</g>
  ),
})
